const scope = 'app/containers/AccountSettings/';

export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
export const SAVE_EDIT_USER = `${scope}SAVE_EDIT_USER`;
export const UPLOAD_IMAGE_USER = `${scope}UPLOAD_IMAGE_USER`;
export const RESET_PASSWORD = `${scope}RESET_PASSWORD`;
export const ADD_COMMUNICATION = `${scope}ADD_COMMUNICATION`;
export const DELETE_ACCOUNT = `${scope}DELETE_ACCOUNT`;
